import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";
import { FeatureResponseFeatureNameEnum } from "../services";
import apiClient from "../utils/api";

interface User {
  username: string; // use userID
  consent: boolean;
}

export interface AvailableFeature {
  featureName: FeatureResponseFeatureNameEnum;
  validUntil: Date | null;
  validFor: "user" | "class";
  validForID: string;
}

interface AuthContextType {
  user: User | null;
  availableFeatures: AvailableFeature[];
  login: (userData: User) => void;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType>({
  user: null,
  availableFeatures: [],
  login: (userData: User) => {}, // This is just a placeholder, should be replaced by actual implementation.
  logout: () => {},
});

const localStorageKey = "authUser";

export const AuthProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [user, setUser] = useState<User | null>(() => {
    // Get the user from localStorage when the component initializes
    const storedUser = localStorage.getItem(localStorageKey);
    if (storedUser) {
      const user: User = JSON.parse(storedUser);
      return user;
    } else {
      return null;
    }
  });

  const [availableFeatures, setAvailableFeatures] = useState<
    AvailableFeature[]
  >([]);

  useEffect(() => {
    // Sync the user to localStorage whenever it changes
    if (user) {
      // apiClient
      //   .sessionPost()
      //   .then(() => {
      //     localStorage.setItem(localStorageKey, JSON.stringify(user));
      //   })
      //   .catch(() => {
      //     setUser(null);
      //     localStorage.removeItem(localStorageKey);
      //   });

      // Grab the available features from the API
      apiClient.featureFlagsControllerListMyFeatures().then((response) => {
        setAvailableFeatures(
          response.map((feature) => ({
            featureName: feature.featureName,
            validUntil: feature.validUntil,
            validFor: feature.targetType as "user" | "class",
            validForID: feature.targetId,
          }))
        );
      });

      localStorage.setItem(localStorageKey, JSON.stringify(user));
    } else {
      localStorage.removeItem(localStorageKey);
    }
  }, [user]);

  const login = (userData: User) => {
    setUser(userData);
    console.log(user);
  };

  const logout = () => {
    localStorage.removeItem("authToken");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, availableFeatures, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
